var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("studip-dialog", {
    attrs: {
      title: _vm.$gettext("Seite exportieren"),
      closeText: _vm.$gettext("Schließen"),
      closeClass: "cancel",
      height: "320",
      width: "610",
    },
    on: {
      close: function close($event) {
        return _vm.showElementExportChooserDialog(false)
      },
    },
    scopedSlots: _vm._u([
      {
        key: "dialogContent",
        fn: function fn() {
          return [
            _c(
              "div",
              {
                staticClass: "square-button-panel",
              },
              [
                _vm.showExportArchiv
                  ? _c("studip-square-button", {
                      attrs: {
                        icon: "file-archive",
                        title: _vm.$gettext("ZIP Datei herunterladen"),
                      },
                      on: {
                        click: function click($event) {
                          return _vm.selectType("archiv")
                        },
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.showExportPdf
                  ? _c("studip-square-button", {
                      attrs: {
                        icon: "file-pdf",
                        title: _vm.$gettext("PDF Datei herunterladen"),
                      },
                      on: {
                        click: function click($event) {
                          return _vm.selectType("pdf")
                        },
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.showOer
                  ? _c("studip-square-button", {
                      attrs: {
                        icon: "oer-campus",
                        title: _vm.$gettext("Auf OER Campus veröffentlichen"),
                      },
                      on: {
                        click: function click($event) {
                          return _vm.selectType("oer")
                        },
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            !_vm.showExportArchiv && !_vm.showExportPdf && !_vm.showOer
              ? _c("courseware-companion-box", {
                  attrs: {
                    mood: "pointing",
                    msgCompanion: _vm.$gettext(
                      "Keine Exportoptionen verfügbar."
                    ),
                  },
                })
              : _vm._e(),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }